var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIoT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.09 336.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #030303;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ef472a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.74,78.06c-15.58-.07-31.16-.14-46.74-.21v181.21h51.38V78.06c-1.71,0-3.17,0-4.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m162.47,245.79c42.56.34,77.63-34.32,77.78-76.88.16-42.93-34.3-77.63-77.24-77.79-42.5-.16-77.4,34.34-77.59,76.69-.19,43,34.03,77.64,77.05,77.98Zm.5-102.93c14.2.04,25.74,11.62,25.63,25.73-.11,14.16-11.65,25.5-25.91,25.45-14.19-.04-25.74-11.64-25.63-25.73.1-14.16,11.64-25.49,25.91-25.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m267.5,78.26v51.67h32.17v128.68h51.52v-128.75h31.9v-51.59h-115.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m63.96,32.43c4.28,5.89,8.57,11.79,12.72,17.49,57.6-36.86,114.85-36.85,172.33-.02,4.14-5.69,8.38-11.52,12.77-17.55-58.81-44.55-143.69-41.73-197.82.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m162.93,314.4c-31.51.03-60.19-9.42-85.92-27.86-4.48,6.16-8.72,11.99-13.11,18.02,59.27,44.66,144.02,41.57,197.82-.1-4.28-5.89-8.58-11.79-13.05-17.94-25.73,18.54-54.34,27.86-85.73,27.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.34,250.34c-2.19,2.99-4.4,5.98-6.59,8.98-2.16,2.97-4.3,5.97-6.44,8.93,43.15,32.54,105.17,30.71,145.04-.09-4.35-5.98-8.7-11.96-13.04-17.94-33.46,24.07-80.94,27.05-118.97.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m222.36,86.59c4.34-5.98,8.68-11.96,13.01-17.93-42.37-32.17-104.52-31.13-145.04.06,4.29,5.9,8.59,11.82,13.04,17.94,34.38-24.72,81.93-26.43,118.99-.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoT);
export default __webpack_public_path__ + "static/media/IoT.eeb1a28c8b6eb4837d874ade36c34933.svg";
export { ForwardRef as ReactComponent };